/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type InsertOrUpdateGasoilPriceMutationVariables = Types.Exact<{
  input: Types.GasoilPriceInput;
}>;


export type InsertOrUpdateGasoilPriceMutation = {
  __typename?: 'Mutation',
  insertOrUpdateGasoilPrice?: {
    __typename?: 'GasoilPrice',
    id: number
  } | null
};

export type DeleteGasoilPriceMutationVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type DeleteGasoilPriceMutation = {
  __typename?: 'Mutation',
  deleteGasoilPrice?: boolean | null
};

export type SyncCoreGasOilPricesMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SyncCoreGasOilPricesMutation = {
  __typename?: 'Mutation',
  syncCoreGasOilPrices?: boolean | null
};


export const InsertOrUpdateGasoilPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertOrUpdateGasoilPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GasoilPriceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insertOrUpdateGasoilPrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertOrUpdateGasoilPriceMutation, InsertOrUpdateGasoilPriceMutationVariables>;
export const DeleteGasoilPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteGasoilPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteGasoilPrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteGasoilPriceMutation, DeleteGasoilPriceMutationVariables>;
export const SyncCoreGasOilPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncCoreGasOilPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncCoreGasOilPrices"}}]}}]} as unknown as DocumentNode<SyncCoreGasOilPricesMutation, SyncCoreGasOilPricesMutationVariables>;